import * as React from 'react';
import { graphql, PageProps } from 'gatsby';

import Page from '../../components/Page';
import Projects from '../../components/Projects';
import Section from '../../components/Section';
import { getCmsDocuments, getLayout } from '../../cms';
import type { RealisationsIntro } from '../../types';

const PROJECT_LIMIT = 500;

const RealisatiesPage: React.FC<PageProps> = ({ data }) => {
  const documents = getCmsDocuments(data);
  const [{ title, html }] = getLayout(
    documents,
    '/references/intro/'
  ) as RealisationsIntro[];

  return (
    <Page title={title}>
      <Section>
        <Section.Title>{title}</Section.Title>
        <Section.Description dangerouslySetInnerHTML={{ __html: html }} />
        <Projects limit={PROJECT_LIMIT} allowClickImage />
      </Section>
    </Page>
  );
};

export const pageQuery = graphql`
  query realisationPage {
    allMarkdownRemark(
      filter: { fields: { filePath: { in: ["/references/intro/"] } } }
    ) {
      edges {
        node {
          html
          frontmatter {
            title
          }
          fields {
            filePath
          }
        }
      }
    }
  }
`;

export default RealisatiesPage;
